import React, { createContext, useContext, useState, useCallback } from "react";

const LoadingContext = createContext({
  showLoading: () => {},
  hideLoading: () => {},
  isLoading: false,
});

export function useLoading() {
  return useContext(LoadingContext);
}

export function LoadingProvider({ children }) {
  const [isLoading, setIsLoading] = useState(false);

  const showLoading = useCallback(() => setIsLoading(true), []);
  const hideLoading = useCallback(() => setIsLoading(false), []);

  return (
    <LoadingContext.Provider value={{ showLoading, hideLoading, isLoading }}>
      {children}
      {/* Global loading overlay */}
      <div
        style={{
          pointerEvents: isLoading ? "auto" : "none",
          opacity: isLoading ? 1 : 0,
          transition: "opacity 0.3s",
        }}
        className="fixed inset-0 z-[9999] flex items-center justify-center"
      >
        {isLoading && (
          <img
            src="https://assets.atomicpay.net/public/pay_square.png"
            alt="Loading..."
            className="animate-ap-fade w-16 h-16"
          />
        )}
        <style>{`
          @keyframes ap-fade {
            0% { opacity: 0.2; }
            50% { opacity: 1; }
            100% { opacity: 0.2; }
          }
          .animate-ap-fade {
            animation: ap-fade 2s infinite cubic-bezier(0.4,0,0.2,1);
          }
        `}</style>
      </div>
    </LoadingContext.Provider>
  );
}
